import axios from 'axios'

export const state = {
  data: null,
  loading: true
}

export const actions = {
  getConfig({ commit }) {
    commit('SET_LOADING', true)
    return axios.get('config').then(promise => {
      commit('RECEIVE_CONFIG', promise.data.results)
    }).finally(() => {
      commit('SET_LOADING', false)
    })
  }
}

export const mutations = {
  RECEIVE_CONFIG(state, data) {
    state.data = data
  },
  SET_LOADING(state, status) {
    state.loading = status
  }
}

export default {
  state,
  actions,
  mutations
}
